import createCtx from '../../../helpers/createCtx';
export const [useProgressBar, ProgressBarContext] = createCtx('ProgressBar');
